import { useCallback, useMemo } from 'react'
import { Chips } from '~/components/chips'
import { useInputMultiSelectContext } from '../../input-multi-select'
import type {
  InputMultiSelectQuantityProps,
  InputMultiSelectScopedProps,
} from '../../input-multi-select.types'
import { InputMultiSelectQuantityContainerVariants } from './index.styles'

export function InputMultiSelectQuantity({
  labels,
  removeItem,
  __scopeInputMultiSelect,
}: InputMultiSelectScopedProps<InputMultiSelectQuantityProps>) {
  const { disabled, readonly, size } = useInputMultiSelectContext(
    'InputMultiSelectLabel',
    __scopeInputMultiSelect
  )

  const upperFirstLetter = useCallback((label: string, oversized?: boolean) => {
    if (oversized) return `+${label}`

    return label.slice(0, 1).toUpperCase() + label.slice(1)
  }, [])

  const customSize = useMemo(
    () => (size === 'lg' || size === 'xl' ? 'ml' : 'sm'),
    [size]
  )

  return (
    <div className={InputMultiSelectQuantityContainerVariants()}>
      {labels.map(({ id, label, oversized }) => {
        const formattedLabel = upperFirstLetter(label, oversized)

        return (
          <Chips.Root
            key={id}
            id={id}
            name={formattedLabel}
            disabled={disabled}
            readOnly={readonly}
            value=""
            size={customSize}
            checked={!oversized}
          >
            <Chips.Input
              id={id}
              name={formattedLabel}
              value=""
              onChange={() => removeItem(id)}
            >
              <Chips.Label>{formattedLabel}</Chips.Label>
            </Chips.Input>
          </Chips.Root>
        )
      })}
    </div>
  )
}
